
import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import type { SnowplowContext, SnowplowModuleContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { SponsoredAdFragmentFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';

const SponsoredRecommendationView = () =>
	import(
		/* webpackChunkName: "sponsored-recommendation.view" */ '@/components/sponsored-recommendations/SponsoredRecommendationView.vue'
	);
const App = namespace('app');

@Component({
	name: 'SponsoredRecommendation',
	components: {
		SponsoredRecommendationView,
	},
})
export default class SponsoredRecommendation extends Vue {
	@Prop({ default: () => [] }) additionalContexts: (SnowplowModuleContext | SnowplowContext)[];
	@Prop({ default: true }) lazy: boolean;
	@Prop({ default: null }) sponsoredAd: SponsoredAdFragmentFragment;

	@App.Getter isSeoUser: boolean;

	@Emit('onSponsoredRecommendationClick')
	onSponsoredRecommendationClick() {}

	get componentWrapper() {
		return this.isSeoUser ? 'NoSSR' : 'LazyHydrate';
	}

	get isRealCampaign() {
		const { sponsoredAd } = this;
		return (
			!!sponsoredAd?.campaign &&
			['Season', 'SingleStepSportEvent'].indexOf(sponsoredAd.campaign.node.__typename || '') === -1
		);
	}

	get isSponsoredRecommendationActive() {
		return this.sponsoredAd && this.sponsoredAd.holdoutGroup === false;
	}
}
